import { teamsClient } from '@atlaskit/teams-client';
import type { TeamWithImageUrls } from '@atlaskit/teams-client/types';

import type { StoreApi } from '../types';

export const unlinkExternalTeam =
	(teamId: string) =>
	async ({ getState, setState }: StoreApi): Promise<void> => {
		try {
			await teamsClient.unlinkTeamFromGroup(teamId);
			const state = getState();

			if (state.teamProfile.teamId !== teamId) {
				return;
			}

			const { teamProfile } = state;
			const currentTeam = teamProfile.data;

			setState({
				...state,
				teamProfile: {
					...teamProfile,
					data: {
						...(currentTeam as TeamWithImageUrls),
						isVerified: false,
						membershipSettings: 'MEMBER_INVITE',
					},
				},
			});
		} catch (error) {
			throw Error('Unable to Unlink the team');
		}
	};
